import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import initSvgIcon from '@/plugins/SvgIcon'
import router from './router'
import App from './App.vue'
import 'ant-design-vue/dist/antd.css'
import 'normalize.css/normalize.css'
import '@/assets/styles/normal.scss'
import '@/assets/styles/ant-theme-file.less'
// import * as at from 'array.prototype.at'
import 'array.prototype.at'
// import { toggleIco } from './utils/toggleIco'
import { baseUrl, CONFIG, ENV } from '@/utils/base-url.js'
//将配置访问路径代码块迁移到main.ts
window.CONFIG = CONFIG //获取baseURL配置
window.baseUrl = baseUrl
window.ENV = ENV
// toggleIco()
// at.shim() // 使用shim方法
const app = createApp(App)
const store = createPinia()
store.use(piniaPluginPersistedstate)
app.use(store)
app.use(router)
app.use(initSvgIcon)
app.mount('#app')
